import type { PublicChurch } from '@/stores/church-store';
import type { AuthenticatedUser } from '@/stores/auth-store';

/** Church policy requires TOTP before privileged console work. */
export const needsTotpEnrollment = (
  church: PublicChurch | null | undefined,
  user: AuthenticatedUser | null | undefined,
): boolean =>
  Boolean(church?.requireTotpForPrivilegedRoles && user && !user.isTotpEnabled);

export const isAccountPath = (pathname: string): boolean =>
  pathname === '/account' || pathname.startsWith('/account/');
